import React from 'react';
import { toggleClass } from '../../util/dom';
 


export const BgisToggleSidebar = () => {
  return (
    <button className='bgis-toggle-sidebar collapsible' onClick={() => { toggleClass('.bgis-map-area','hide-sidebar'); return false; }}>
      <i className="bgis-icon bgis-sidebar-icon-toggle"></i>
    </button>);

};